export default __webpack_public_path__ + "static/media/dis.dee86837.png";